export default __webpack_public_path__ + "static/media/biticc.4bd311e3.png";